/**
 * 		Bezeichnungen Alex/Martin übersetzen
 */
let bez = {};
// Clientseitige Variabelnamen
bez["i5-kurzfassung"] = "client_patient_abstract";
bez["i6-datum"] = "client_date";
bez["i6-zeit"] = "client_time";
bez[""] = "client_unread";
bez["i6-datum-text"] = "client_datetime_text";
bez["i8-perfusor-text"] = "client_perfusor_text";
bez["i8-fahrzeug-text"] = "client_vehicle_text";
bez["i8-rollstuhl-text"] = "client_wheelchair_text";
bez["i8-selbstzahler"] = "missions_additionals_selfpay";
bez["i8-selbstzahler-text"] = "missions_additionals_selfpay_text";

// Tabelle missions
bez["i0-ausfuellzeit"] = "log_fillout_time";
bez["i0-mission-nummer"] = "missions_id";
bez["i0-letzerBenutzer"] = "missions_lasteditor";
bez["i0-letzerBenutzerName"] = "missions_lasteditorname";
bez["i1-id"] = "missions_customer_id";
bez["i1-bezeichnung"] = "missions_customer_hospitalname";
bez["i1-bezeichnung-id"] = "missions_customer_hospitalid";
bez["i1-station"] = "missions_customer_wardname";
bez["i1-station-id"] = "missions_customer_wardid";
bez["i1-kontaktperson"] = "missions_customer_name";
bez["i1-telefon"] = "missions_customer_phone";
bez["i1-datum"] = "missions_creation_date";
bez["i1-zeit"] = "missions_creation_time";
bez["i3-transportgrund"] = "missions_transport_type";
bez["i3-untersuch"] = "missions_examination";
bez["i10-transportzeit"] = "missions_transport_duration";
bez["i10-transportzeit-man"] = "missions_transport_duration_man";
bez["i10-transportdistanz"] = "missions_transport_distance";
bez["i10-transportdistanz-link"] = "missions_transport_link";
bez[""] = "missions_patient";
bez["i6-abholdatum"] = "missions_pickup_date";
bez["i6-abholzeit"] = "missions_pickup_time";
bez["i6-sofort"] = "missions_pickup_immediately";
bez["i6-zielortdatum"] = "missions_destination_date";
bez["i6-zielortzeit"] = "missions_destination_time";
bez["i6-flexibel"] = "missions_time_flexible";
bez["i6-fixpunkt"] = "missions_fixpoint";
bez["i0-status"] = "missions_status";
bez["i0-dispoStatus"] = "missions_dispo_status";
bez["i0-imGebrauch"] = "missions_in_use";
bez["i0-knzbemerkung"] = "missions_dispo_remarks";
bez["i0-elisnummer"] = "missions_knznr";
bez["i0-begruendung"] = "missions_external_reason";
bez["i0-fahrzeug"] = "missions_vehicle";
bez["i0-fahrzeug-id"] = "vehicles_id";
bez["i0-fahrzeug-kurzname"] = "vehicles_shortname";
bez["i0-hatRueckfahrt"] = "missions_return_mission";
bez["i0-aktualisiert"] = "missions_updated";
bez["i0-gedruckt"] = "missions_printed";
bez["i0-els3ID"] = "missions_els3_id";

// Tabelle missions_additionals
bez["i9-keine"] = "missions_additionals_escort_no";
bez["i9-kispiteam"] = "missions_additionals_escort_kispi";
bez["i9-hebamme"] = "missions_additionals_escort_midwife";
bez["i9-polizei"] = "missions_additionals_escort_police";
bez["i9-familie"] = "missions_additionals_escort_family";
bez["i9-begleitung"] = "missions_additionals_escort_enum";
bez["i9-begleitung-text"] = "missions_additionals_escort";
bez["i8-position"] = "missions_additionals_position";
bez["i8-liegend"] = "missions_additionals_position_lying";
bez["i8-lying"] = "missions_additionals_position_lying1";
bez["i8-sitzend"] = "missions_additionals_position_sitting";
bez["i8-sitting"] = "missions_additionals_position_sitting1";
bez["i8-walking"] = "missions_additionals_position_walking";
bez["i8-fahrzeug"] = "missions_additionals_vehicle_type";
bez["i8-rollstuhl"] = "missions_additionals_wheelchair_type";

// Tabelle missions_destinations
bez["i4-bezeichnung"] = "missions_destinations_hospitalname";
bez["i4-bezeichnung-id"] = "missions_destinations_hospitalid";
bez["i4-station"] = "missions_destinations_wardname";
bez["i4-station-id"] = "missions_destinations_wardid";
bez["i4-haus"] = "missions_destinations_house";
bez["i4-stock"] = "missions_destinations_floor";
bez["i4-zimmer"] = "missions_destinations_room";
bez["i4-strasse"] = "missions_destinations_street";
bez["i4-plz"] = "missions_destinations_zip";
bez["i4-ort"] = "missions_destinations_city";
bez["i4-telefon"] = "missions_destinations_phone";
bez["i4-land"] = "missions_destinations_country";
bez["i4-latitude"] = "missions_destinations_latitude";
bez["i4-longitude"] = "missions_destinations_longitude";

// Tabelle missions_equipment
bez["i8-infusion"] = "missions_equipment_infusion";
bez["i8-monitor"] = "missions_equipment_monitoring";
bez["i8-sauerstoff"] = "missions_equipment_oxygen";
bez["i8-isolette"] = "missions_equipment_isolette";
bez["i8-gepaeck"] = "missions_equipment_gepaeck";
bez["i8-beatmet"] = "missions_equipment_ventilation";
bez["i8-perfusor"] = "missions_equipment_perfusor";

// Tabelle missions_pickups
bez["i2-bezeichnung"] = "missions_pickups_hospitalname";
bez["i2-bezeichnung-id"] = "missions_pickups_hospitalid";
bez["i2-station"] = "missions_pickups_wardname";
bez["i2-station-id"] = "missions_pickups_wardid";
bez["i2-haus"] = "missions_pickups_house";
bez["i2-stock"] = "missions_pickups_floor";
bez["i2-zimmer"] = "missions_pickups_room";
bez["i2-strasse"] = "missions_pickups_street";
bez["i2-plz"] = "missions_pickups_zip";
bez["i2-ort"] = "missions_pickups_city";
bez["i2-telefon"] = "missions_pickups_phone";
bez["i2-anfahrtszeit"] = "missions_pickups_reachtime";
bez["i2-land"] = "missions_pickups_country";
bez["i2-latitude"] = "missions_pickups_latitude";
bez["i2-longitude"] = "missions_pickups_longitude";

// Tabelle patients
bez["i5-id"] = "patients_id";
bez["i5-patient-verschl-1"] = "patients_patient_locked1";
bez["i5-patient-verschl-2"] = "patients_patient_locked2";
bez["i5-patient-verschl-3"] = "patients_patient_locked3";
bez["i5-diagnose-verschl-1"] = "patients_remark_locked1";
bez["i5-diagnose-verschl-2"] = "patients_remark_locked2";
bez["i5-diagnose-verschl-3"] = "patients_remark_locked3";
bez["i5-schluessel-1"] = "patients_key1";
bez["i5-schluessel-2"] = "patients_key2";
bez["i5-schluessel-3"] = "patients_key3";
bez["i5-initiale"] = "patients_initial";
bez["i5-geschlecht"] = "patients_gender";
bez["i5-fallnummer"] = "patients_sapid";
bez["i8-isoliert"] = "patients_isolated";
// Wird beim Disponenten gebraucht, ø offiziell!
bez["i5-patient-verschl-"] = "patients_patient_locked";
bez["i5-diagnose-verschl-"] = "patients_remark_locked";
bez["i5-schluessel-"] = "patients_key";

// Tabelle transportypes
bez["i3-transportgrund-text"] = "transporttypes_name";
bez["i3-transportgrund-dringlichkeit"] = "transporttypes_priority";

// Tabelle examinations
bez["i3-untersuch-text"] = "examinations_name";
globalThis.bez = bez;

// 2. Array umgedreht erstellen
globalThis.bezInv = {};
$(document).ready(function () {
  $.each(bez, function (index, value) {
    globalThis.bezInv[value] = index;
  });
});
// Ende Bezeichnungen Alex/Martin übersetzen

Foundation.Abide.defaults.validators["diagnose"] = function ($el) {
  return $el.val().length <= 400;
};
Foundation.Abide.defaults.patterns["zeit"] =
  /^(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]){1,2}$/;
